import { ApplicationRef, Injectable } from '@angular/core';
import { IPropertyImage } from '../../interfaces/property';

@Injectable({
  providedIn: 'root'
})
export class DynamicGalleryService {
  album: IPropertyImage[];
  title: string;
  imageIndex: number;
  isShowTags: boolean;
  isRoomCategory: boolean;
  componentRef;
  isHowItWorks?: boolean;

  constructor(private readonly appRef: ApplicationRef) {}

  removeComponent() {
    this.appRef.detachView(this.componentRef.hostView);
    this.componentRef.destroy();
  }
}
